import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { commodities, currencies } from '../../../shared/selectedTickers';
import { getDeviceBreakpoint } from '../../service/device';
import withPageTitle from '../../hoc/withPageTitle';

import FrontComponent from '../../components/front/FrontComponent';
import Indices from '../../components/front/Indices';
import Overview from '../front/overview/Overview';

function mapStateToProps({ device, indices }) {
    return {
        title: 'overview',
        breakpoint: getDeviceBreakpoint(device.windowWidth),
        indices: indices.front.symbols,
    };
}

class FrontPage extends Component {
    static propTypes = {
        indices: PropTypes.array,
        breakpoint: PropTypes.string,
    };

    render() {
        return (
            <div>
                <Indices
                    breakpoint={this.props.breakpoint}
                    indices={this.props.indices}
                />
                <Overview />
                <FrontComponent
                    title="currency"
                    tickers={currencies}
                    link="/valuta"
                    breakpoint={this.props.breakpoint}
                />
                <FrontComponent
                    title="commodities"
                    tickers={commodities}
                    link="/ravaror"
                    breakpoint={this.props.breakpoint}
                />
            </div>
        );
    }
}

export default connect(mapStateToProps)(
    withPageTitle(FrontPage)
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/pages/FrontPage.js
 **/